<template>
    <div class="container">
    <v-title>
        Guides
    </v-title>
    </div>
</template>
<script>
    import vTitle from '@/components/v-title';

    export default {
        components: {vTitle},
        name: 'guides',
    };
</script>
